
import React from 'react'
import './FooterActionBox.scss'
import PropTypes from 'prop-types'
import classNames from 'classnames'

export const FooterActionBox = ({ children, isOpen, className }) => {
  const classContainer = classNames('footer-action-box', className, {
    'open': isOpen
  })
  return (
    <div className='footer-action-box_container'>
      <div className={classContainer}>
        <div className='row m-bottom-0'>
          {children}
        </div>
      </div>
    </div>
  )
}

FooterActionBox.defaultProps = {
  disabled: false
}

FooterActionBox.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool
}
